// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3PsIf","footer":"ModalUpdate_footer__2Wg4Z"};